let initialState = {
	bar: null,
	pie: null,
	stack: null,
	line: null,
	area: null,
	heat: null,
	wordcloud: null,
	sunburst: null,
	geo: null,
	venn: null,
	density: null,
	wordcloudType: "regular",
	bubble: null,
	mapPie: null,
	barConversion: "bar",
};
const DisplayChart = (state = initialState, action) => {
	switch (action.type) {
		case "SET_BAR":
			return {
				...state,
				bar: action.payload,
			};
		case "SET_PIE":
			return {
				...state,
				pie: action.payload,
			};
		case "SET_STACKBAR":
			return {
				...state,
				stack: action.payload,
			};
		case "SET_LINE":
			return {
				...state,
				line: action.payload,
			};
		case "SET_AREA":
			return {
				...state,
				area: action.payload,
			};
		case "SET_HEAT":
			return {
				...state,
				heat: action.payload,
			};
		case "SET_WORDCLOUD":
			return {
				...state,
				wordcloud: action.payload,
			};
		case "SET_SUNBURST":
			return {
				...state,
				sunburst: action.payload,
			};
		case "SET_GEO":
			return {
				...state,
				geo: action.payload,
			};
		case "SET_VENN":
			return {
				...state,
				venn: action.payload,
			};
		case "SET_DENSITY":
			return {
				...state,
				density: action.payload,
			};
		case "SET_WORDCLOUDTYPE":
			return {
				...state,
				wordcloudType: action.payload,
			};
		case "SET_BUBBLE":
			return {
				...state,
				bubble: action.payload,
			};
		case "SET_MAP_PIE":
			return {
				...state,
				mapPie: action.payload,
			};
		case "SET_BAR_CONVERSION":
			return {
				...state,
				barConversion: action.payload,
			};
		case "SET_CLEARALL":
			return {
				...state,
			};

		default:
			return state;
	}
};

export default DisplayChart;
